export const API_ROOT = process.env.NODE_ENV === "production" ? "/api/" : "/api/";
